module.exports = __webpack_public_path__ + "media/images/flags/MX-47f8cb4e6c9372a9d19d10ac1ccbae01.svg";